/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Order_Action_Carrier_DeliveredInputs */

const vi_order_action_carrier_delivered = /** @type {(inputs: Order_Action_Carrier_DeliveredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bên vận chuyển báo đã giao`)
};

/**

* @param {Order_Action_Carrier_DeliveredInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const order_action_carrier_delivered = /** @type {((inputs?: Order_Action_Carrier_DeliveredInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Order_Action_Carrier_DeliveredInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_order_action_carrier_delivered(inputs)
});